// FormazionePage.jsx
import React, { useState , useEffect} from 'react';
import { Box, TextField , IconButton, Tooltip} from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import itLocale from 'date-fns/locale/it';
import MonthlyFormazione from './MonthlyFormazione';
import { withTranslation } from 'react-i18next';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'; // Icona freccia sinistra
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'; // Icona freccia destra
import { Typography} from "@mui/material";

const FormazionePage = ({ t, history ,location}) => {
  // 1. INIZIALIZZAZIONE SINCRONA
  // Usiamo una funzione anonima dentro useState: viene eseguita UNA SOLA VOLTA
  // alla "nascita" del componente, ignorando i rimontaggi successivi.
  const [selectedDate, setSelectedDate] = useState(() => {
    const state = location.state;
    if (state && state.targetYear !== undefined) {
      return new Date(state.targetYear, state.targetMonth, 1);
    }
    return new Date();
  });

  // 2. BOOLEAN DI CONTROLLO
  const [isReady, setIsReady] = useState(false);
  const [targetEventId, setTargetEventId] = useState(location.state?.targetEventId);
  const clearTargetEvent = () => setTargetEventId(null);

  useEffect(() => {
    setIsReady(true);
  }, []);

  const year = selectedDate.getFullYear();
  const month = selectedDate.getMonth();
  const maxYear = new Date().getFullYear() + 1;
  const maxDate = new Date(`${maxYear}-12-31`);



  // NUOVE FUNZIONI PER LA NAVIGAZIONE CON LE FRECCE
  const handlePrevMonth = () => {
    const newDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() - 1, 1);
    if (newDate >= new Date('2025-06-01')) { // Controlla minDate
        setSelectedDate(newDate);
    }
  };

  const handleNextMonth = () => {
    const newDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1);
    if (newDate <= maxDate) { // Controlla maxDate
        setSelectedDate(newDate);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={itLocale}>
      <div style={{ margin: "1.2rem 0 .5rem 1.2rem" }}>
        <Typography variant="h6" component="h2">
          {t("Calendario Formazione")}
        </Typography>
      </div>


        {/* DATEPICKER ESISTENTE */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center',p: '5px' }}>
        {/* PULSANTE MESE PRECEDENTE */}
        <Tooltip title={t("Mese Precedente")}>
          <IconButton 
            onClick={handlePrevMonth} 
            disabled={selectedDate.getFullYear() <= 2025 && selectedDate.getMonth() <= 5}
            size="medium"
            sx={{ 
                my: 0.5,
                mr: 1, // ⬅️ AGGIUNTO MARGINE DESTRO
                bgcolor: 'primary.main',
                color: 'white',
                '&:hover': {
                    bgcolor: 'primary.dark', // Hover è già corretto
                },
                '&.Mui-disabled': {
                    bgcolor: 'rgba(0, 0, 0, 0.12)',
                    color: 'rgba(255, 255, 255, 0.4)',
                }
            }}
        >
        <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>
        </Tooltip>
        <DatePicker
          views={['year', 'month']}
          minDate={new Date('2025-06-01')}
          maxDate={maxDate}
          value={selectedDate}
          onChange={(newValue) => setSelectedDate(newValue)}
          renderInput={(params) => (
                          <TextField {...params} 
                            helperText={null} 
                            size="small"
                            sx={{
                              width: 'fit-content',  // 👈 Si adatta al contenuto
                              minWidth: '120px',     // 👈 Larghezza minima
                              '& .MuiInputBase-input': {
                                fontSize: '0.9rem',  // 👈 Carattere più piccolo
                                py: 1,             // 👈 Padding verticale minimo
                                px: 1,               // 👈 Padding orizzontale minimo
                                with: "auto"
                              },
                              '& .MuiInputBase-root': {
                                height: '36px',      // 👈 Altezza fissa compatta
                              }
                            }}/>
                        )}
          
        />
        {/* PULSANTE MESE SUCCESSIVO */}
        <Tooltip title={t("Mese Successivo")}>
                    <IconButton 
            onClick={handleNextMonth} 
            disabled={selectedDate.getFullYear() >= maxDate.getFullYear() && selectedDate.getMonth() >= maxDate.getMonth()} // Disabilita se > maxDate
            size="medium"
            // ⬅️ NUOVE PROPRIETÀ DI STILE
            sx={{ 
                my: 0.5,ml: 1,
                bgcolor: 'primary.main', // Sfondo blu
                color: 'white',         // Icona bianca
                '&:hover': {
                    bgcolor: 'primary.dark', // Effetto hover leggermente più scuro
                },
                // Assicura che l'icona bianca sia visibile anche quando disabilitato
                '&.Mui-disabled': {
                    bgcolor: 'rgba(0, 0, 0, 0.12)', // Colore grigio standard di disabilitazione
                    color: 'rgba(255, 255, 255, 0.4)', // Icona grigia chiara
                }
            }}
        >
            <ArrowForwardIosIcon fontSize="small" />
        </IconButton>
        </Tooltip>

      </Box>
      {isReady && (
          <MonthlyFormazione 
            year={year} 
            month={month} 
            t={t}
            targetEventId={targetEventId}
            onEventAutoOpened={clearTargetEvent}
          />
        )}
    </LocalizationProvider>
  );
};

export default withTranslation()(FormazionePage);
